import React from "react";
import DataMigrationView from "../views/DataMigrationView";
import { renderDashboardMenuContent, renderDefaultDashboardContent } from "./dashboardContent";
import { renderStudentsMenuContent, renderTeachersMenuContent } from "./studentTeacherContent";
import { renderAttendanceMenuContent, renderCounselingMenuContent } from "./attendanceCounselingContent";
import { renderScheduleMenuContent, renderFinanceMenuContent } from "./scheduleFinanceContent";
import { renderStatisticsMenuContent } from "./statisticsAssistantContent";

export function renderMainContent(params) {
    const {
        activeMenu,
        state,
        actions
    } = params;
    const {
        students,
        teachers,
        schedules,
        finances,
        annualBudget,
        userProfile,
        meetingMinutes,
        visitLogs,
        isDashboardSettingsOpen,
        isAaronOpen,
        selectedDepartment,
        myDepartments,
        currentTheme,
        chatHistory,
        earnedBadges,
        level,
        levelProgress,
        totalPoints,
        isMobile,
        attendanceLogs,
        studentListType,
        studentSearchTerm,
        tourAction,
        studentToEdit,
        targetDate,
        attendanceSearchQuery,
        attendanceTargetGroup,
        targetStudentId,
        targetTeacherId,
        targetStatisticsSection,
        detailReturnMenu,
        targetLogId,
        counselingSearchQuery,
        counselingTargetGroup,
        user,
        isStatsEditMode,
        isStatsSettingsOpen
    } = state;
    const {
        setActiveMenu,
        addItem,
        updateItem,
        deleteItem,
        bulkAddItem,
        bulkDeleteItem,
        setIsDashboardSettingsOpen,
        handleUpdateMyDepartments,
        setChatHistory,
        setIsProfileModalOpen,
        setStudentListType,
        setStudentSearchTerm,
        handleNavigateToAttendance,
        handleNavigateToLog,
        setStudentToEdit,
        incrementStat,
        handleOpenCheerModal,
        checkAndAwardBadges,
        setTargetDate,
        setAttendanceSearchQuery,
        setAttendanceTargetGroup,
        refreshAttendanceLogs,
        setTargetLogId,
        setCounselingSearchQuery,
        setCounselingTargetGroup,
        setTargetStudentId,
        setTargetTeacherId,
        setTargetStatisticsSection,
        setDetailReturnMenu,
        handleUpdateAnnualBudget,
        setIsStatsEditMode,
        setIsStatsSettingsOpen,
        setIsAaronOpen,
        setSelectedDepartment
    } = actions;

    let content = null;
    switch (activeMenu) {
        case "dashboard":
            content = renderDashboardMenuContent({
                students,
                schedules,
                finances,
                annualBudget,
                setActiveMenu,
                addItem,
                updateItem,
                deleteItem,
                userProfile,
                meetingMinutes,
                visitLogs,
                isDashboardSettingsOpen,
                setIsDashboardSettingsOpen,
                isAaronOpen,
                selectedDepartment,
                myDepartments,
                handleUpdateMyDepartments,
                currentTheme,
                chatHistory,
                setChatHistory,
                earnedBadges,
                level,
                levelProgress,
                totalPoints,
                setIsProfileModalOpen,
                setTargetStatisticsSection,
                setStudentListType,
                setTargetStudentId,
                setDetailReturnMenu
            });
            break;
        case "students":
            content = renderStudentsMenuContent({
                isMobile,
                students,
                teachers,
                visitLogs,
                attendanceLogs,
                studentListType,
                setStudentListType,
                studentSearchTerm,
                setStudentSearchTerm,
                addItem,
                updateItem,
                deleteItem,
                bulkAddItem,
                bulkDeleteItem,
                handleNavigateToAttendance,
                handleNavigateToLog,
                tourAction,
                studentToEdit,
                setStudentToEdit,
                selectedDepartment,
                myDepartments,
                userProfile,
                currentTheme,
                incrementStat,
                handleOpenCheerModal,
                targetStudentId,
                setTargetStudentId,
                targetTeacherId,
                setTargetTeacherId,
                detailReturnMenu,
                setDetailReturnMenu,
                setActiveMenu
            });
            break;
        case "teachers":
            content = renderTeachersMenuContent({
                teachers,
                meetingMinutes,
                addItem,
                updateItem,
                deleteItem,
                bulkAddItem,
                bulkDeleteItem,
                tourAction,
                attendanceLogs,
                visitLogs,
                handleNavigateToAttendance,
                handleNavigateToLog,
                selectedDepartment,
                myDepartments,
                userProfile,
                currentTheme,
                handleOpenCheerModal,
                targetTeacherId,
                setTargetTeacherId,
                detailReturnMenu,
                setDetailReturnMenu,
                setActiveMenu
            });
            break;
        case "attendance":
            content = renderAttendanceMenuContent({
                students,
                teachers,
                updateItem,
                deleteItem,
                incrementStat,
                checkAndAwardBadges,
                visitLogs,
                attendanceLogs,
                targetDate,
                setTargetDate,
                tourAction,
                attendanceSearchQuery,
                setAttendanceSearchQuery,
                attendanceTargetGroup,
                setAttendanceTargetGroup,
                selectedDepartment,
                currentTheme,
                refreshAttendanceLogs,
                userProfile
            });
            break;
        case "counseling":
            content = renderCounselingMenuContent({
                students,
                teachers,
                visitLogs,
                attendanceLogs,
                addItem,
                deleteItem,
                updateItem,
                targetStudentId,
                targetLogId,
                setTargetLogId,
                counselingSearchQuery,
                setCounselingSearchQuery,
                counselingTargetGroup,
                setCounselingTargetGroup,
                selectedDepartment,
                user,
                userProfile,
                currentTheme
            });
            break;
        case "schedule":
            content = renderScheduleMenuContent({
                schedules,
                students,
                teachers,
                addItem,
                updateItem,
                deleteItem,
                selectedDepartment,
                userProfile,
                currentTheme,
                setActiveMenu,
                setStudentListType,
                setTargetStudentId,
                setTargetTeacherId,
                setTargetStatisticsSection,
                setDetailReturnMenu
            });
            break;
        case "finance":
            content = renderFinanceMenuContent({
                finances,
                annualBudget,
                handleUpdateAnnualBudget,
                addItem,
                deleteItem,
                updateItem,
                userProfile,
                selectedDepartment,
                currentTheme
            });
            break;
        case "statistics":
            content = renderStatisticsMenuContent({
                students,
                teachers,
                attendanceLogs,
                finances,
                annualBudget,
                visitLogs,
                selectedDepartment,
                currentTheme,
                isStatsEditMode,
                setIsStatsEditMode,
                isStatsSettingsOpen,
                setIsStatsSettingsOpen,
                setActiveMenu,
                setStudentListType,
                setTargetStudentId,
                targetStatisticsSection,
                setTargetStatisticsSection,
                setDetailReturnMenu
            });
            break;
        case "ai-assistant":
            // [REMOVED] Aaron AI tab removed - AI features now in Statistics
            content = renderStatisticsMenuContent({
                students,
                teachers,
                attendanceLogs,
                finances,
                annualBudget,
                visitLogs,
                selectedDepartment,
                currentTheme,
                isStatsEditMode,
                setIsStatsEditMode,
                isStatsSettingsOpen,
                setIsStatsSettingsOpen,
                setActiveMenu,
                setStudentListType,
                setTargetStudentId,
                targetStatisticsSection,
                setTargetStatisticsSection,
                setDetailReturnMenu
            });
            break;
        case "migration":
            content = <DataMigrationView theme={currentTheme} />;
            break;
        default:
            content = renderDefaultDashboardContent({
                students,
                teachers,
                attendanceLogs,
                visitLogs,
                schedules,
                finances,
                annualBudget,
                setActiveMenu,
                selectedDepartment,
                currentTheme,
                userProfile,
                earnedBadges,
                level,
                levelProgress,
                totalPoints,
                setIsProfileModalOpen
            });
            break;
    }

    return content;
}
